import formState  from "./states/form";
import {tableState} from "./states/table";

const state = () => ({form: {...formState}, table: {...tableState}})

export default state
